import { render, staticRenderFns } from "./AddWebpagesToSubscribedDomain.vue?vue&type=template&id=5ffb71bd&scoped=true&"
import script from "./AddWebpagesToSubscribedDomain.vue?vue&type=script&lang=js&"
export * from "./AddWebpagesToSubscribedDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb71bd",
  null
  
)

export default component.exports